module.exports = __webpack_public_path__ + "static/media/card_prototype.e2229f5a.png";